import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

type Width = "sm" | "md" | "lg";

const widths: Record<Width, string> = {
  sm: "max-w-2xl",
  md: "max-w-3xl",
  lg: "max-w-4xl",
};

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  width?: Width;
}

export function Container({ width = "md", className, ...props }: ContainerProps) {
  return <div className={cn("mx-auto w-full px-6", widths[width], className)} {...props} />;
}
